import Vue from 'vue'
import VueI18n from 'vue-i18n'
import en from './locales/en'
import zhTW from './locales/zh-TW'

Vue.use(VueI18n)

const detectLocale = () => {
  const saved = localStorage.getItem('opcardx_lang')
  if (saved) return saved
  const lang = navigator.language || navigator.userLanguage || 'en'
  const detected = lang.startsWith('zh') ? 'zh-TW' : 'en'
  // 首次检测后立即写入 localStorage，确保和 store 保持一致
  localStorage.setItem('opcardx_lang', detected)
  return detected
}

const i18n = new VueI18n({
  locale: detectLocale(),
  fallbackLocale: 'en',
  messages: { en, 'zh-TW': zhTW }
})

export function setLocale (lang) {
  i18n.locale = lang
  localStorage.setItem('opcardx_lang', lang)
  document.documentElement.lang = lang
}

export default i18n